// used for collecting analytics data only
export default {
  INACTIVE: 'inactive',
  BACKGROUND: 'background',
  LOGIN: 'login',
};
